"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    pages: _propTypes.default.number.isRequired,
    activeIndex: _propTypes.default.number,
    onSelection: _propTypes.default.func,
    pageColor: _propTypes.default.string,
    activePageColor: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    theme: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    pageAltTexts: _propTypes.default.arrayOf(_propTypes.default.string)
  },
  DefaultProps: {
    activeIndex: 0,
    pageColor: _constant2.BANNER_PAGINATION_COLOR.INACTIVE,
    activePageColor: _constant2.BANNER_PAGINATION_COLOR.ACTIVE,
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;